export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/clothing_apparel.88a3e05.svg";